import VehicleNavigator from './VehicleNavigator'

export default VehicleNavigator
